import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const LISTS_QUERY_KEY = "enrichment:lists";

const BASE_EXPORT_QUERY_KEY = "enrichment:export";
const COLUMN_CONFIG_QUERY_KEY = "column-config";

export const enrichmentQueryKeys = {
    lists() {
        return [LISTS_QUERY_KEY] as const;
    },

    export() {
        return [BASE_EXPORT_QUERY_KEY] as const;
    },

    exportColumnConfig() {
        return [BASE_EXPORT_QUERY_KEY, COLUMN_CONFIG_QUERY_KEY] as const;
    },
} satisfies QueryKeyFactory;
